
















import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class AddEmailDialog extends CommonBase {
    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    email: string | null = null;

    save() {
        this.$emit("add-email", this.email);
        this.opened = false;
    }

    close() {
        this.opened = false;
    }
}
